
export const optionsModalidadeDaBaseDeCálculo = [
  { key: 0, text: "0 - Aliquota" },
  { key: 1, text: "1 - Unidade" },
];
